<script lang="ts">
	export let active = false;

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="30"
	height="30.055"
	viewBox="0 0 30 30.055"
	class:active
	on:click>
	<g>
		<path
			d="M763.8 74.941a13.785 13.785 0 1 1-13.782 13.785A13.8 13.8 0 0 1 763.8 74.941m0-1.218a15 15 0 1 0 15 15 15 15 0 0 0-15-15z"
			transform="translate(-748.8 -73.723)" />
		<path
			d="M763.8 90.045a32.84 32.84 0 0 1 10.169 1.424c2.229.759 3.613 1.757 3.613 2.606s-1.385 1.847-3.613 2.606a37.019 37.019 0 0 1-20.338 0c-2.229-.759-3.613-1.757-3.613-2.606s1.385-1.847 3.613-2.606a32.837 32.837 0 0 1 10.169-1.424m0-1.077c-8.285 0-15 2.286-15 5.107s6.715 5.108 15 5.108 15-2.287 15-5.108-6.716-5.107-15-5.107z"
			transform="translate(-748.8 -79.017)" />
		<path
			d="M768.484 75.033c4.454 0 8.216 6.313 8.216 13.785s-3.763 13.785-8.216 13.785-8.216-6.312-8.216-13.785 3.763-13.785 8.216-13.785m0-1.218c-5.265 0-9.533 6.717-9.533 15s4.268 15 9.533 15 9.533-6.717 9.533-15-4.268-15-9.533-15z"
			transform="translate(-753.483 -73.766)" />
		<path
			d="M770.96 75.2c.7 1.111 1.812 5.742 1.812 13.618s-1.109 12.507-1.812 13.619c-.7-1.111-1.812-5.742-1.812-13.619s1.109-12.507 1.812-13.618m0-1.385c-1.6 0-2.89 6.717-2.89 15s1.294 15 2.89 15 2.889-6.717 2.889-15-1.294-15-2.889-15z"
			transform="translate(-755.96 -73.766)" />
	</g>
</svg>

<style lang="scss">
	svg {
		&:hover {
			cursor: pointer;
			path {
				fill: #bcbfc3;
			}
		}

		&.active {
			path {
				fill: #bcbfc3;
			}
		}

		path {
			transition: all 0.5s;
			fill: #6d6f76;
		}
	}

</style>
